import AppRoutes from "AppRoutes";
import { DisplayUser } from "components/DisplayFields/DisplayUser";
import { useLayout, usePermissions, useTranslations } from "providers";
import { useAuthentication } from "providers";

import { HeaderMenuDropdown } from "./HeaderMenuDropdown";

interface UserMenuProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const UserMenu: React.FC<UserMenuProps> = ({ isOpen, setIsOpen }) => {
  const i18n = useTranslations();
  const { permissions } = usePermissions();
  const { logout } = useAuthentication();
  const { handleNavClick } = useLayout();

  const id = "user-menu";
  const user = permissions?.user;
  if (!user) {
    return null;
  }

  const trigger = (
    <>
      <div className="sbb-header-persona">
        <DisplayUser value={user} title={user.displayName} showUrl={false} showSubTitle={false} />
      </div>
      <div className="sbb-header-nav-item-icon ms-2">
        <i className="ms-Icon ms-Icon--ChevronDown" />
      </div>
    </>
  );

  return (
    <HeaderMenuDropdown isOpen={isOpen} setIsOpen={setIsOpen} trigger={trigger} id={id}>
      <a
        className="dropdown-item"
        onClick={(e) => {
          e.preventDefault();
          const url = AppRoutes.getBackendUrl("/users/preferences");
          handleNavClick(url);
        }}
        type="button"
      >
        <span className="text">{i18n.Page_UserPreferences_Title}</span>
      </a>

      <div className="dropdown-divider" />

      <button className="dropdown-item dropdown-item-icon" onClick={() => logout()} type="button">
        <i className="ms-Icon ms-Icon--SignOut" />
        <span className="text">{i18n.Logout}</span>
      </button>
    </HeaderMenuDropdown>
  );
};
